import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { UserRoleActionType, UserRolesAction } from '../actionTypes/userRole';

export const getAllUserRoles =
    () => async (dispatch: Dispatch<UserRolesAction>) => {
        const response = await SuSyApi.get(`/userRole`);
        dispatch({
            type: UserRoleActionType.GET_ALL_USER_ROLES,
            payload: response.data,
        });
    };
